import { page } from './api'

export const getListValues = (listId:string) => {
  return page.get(`${listId}/values`)
}

export const getArchivedEmails = (listId:string) => {
  return page.get(`${listId}/emails`)
}

export const getListValuesWithLambda = (listId:string) => {
  return page.get(`${listId}/values`)
}